export default function ParaQuemE() {
  return (
    <section className="relative py-16 md:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid lg:grid-cols-2 gap-8 md:gap-16 items-center max-w-7xl mx-auto">
          {/* Image */}
          <div className="relative order-2 lg:order-1">
            <div className="relative rounded-2xl md:rounded-3xl overflow-hidden border border-neon-purple/30 shadow-[0_0_40px_rgba(139,92,246,0.3)] md:shadow-[0_0_60px_rgba(139,92,246,0.3)]">
              <img 
                src="https://static.readdy.ai/image/9dca404c9b2236a1a1235bd6ca7530fb/c43f1219a120d311a6c8e6e1d70c7b43.png"
                alt="Criança usando IA com hologramas"
                className="w-full h-auto object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-br from-neon-purple/20 via-transparent to-neon-blue/20"></div>
            </div>

            {/* Floating Card */}
            <div className="absolute -bottom-4 md:-bottom-6 -right-4 md:-right-6 bg-dark-800/90 backdrop-blur-xl border border-neon-purple/40 rounded-xl md:rounded-2xl p-4 md:p-6 shadow-[0_0_30px_rgba(139,92,246,0.4)] md:shadow-[0_0_40px_rgba(139,92,246,0.4)] max-w-[180px] md:max-w-xs">
              <div className="flex items-center gap-3 md:gap-4">
                <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br from-neon-purple to-neon-blue rounded-lg md:rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-lightbulb-flash-fill text-2xl md:text-3xl text-white"></i>
                </div>
                <div>
                  <p className="text-white font-bold text-sm md:text-lg">Aprendizado</p>
                  <p className="text-neon-purple font-semibold text-xs md:text-base">10x Mais Rápido</p>
                </div>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="space-y-6 md:space-y-8 order-1 lg:order-2">
            <div className="inline-flex items-center gap-2 px-3 md:px-4 py-2 rounded-full bg-neon-purple/10 border border-neon-purple/30 backdrop-blur-sm">
              <i className="ri-user-star-fill text-neon-purple text-sm md:text-base"></i>
              <span className="text-neon-purple text-xs md:text-sm font-semibold tracking-wide">PARA QUEM É</span>
            </div>

            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight">
              Para Crianças e Adolescentes Que Querem
              <span className="block bg-gradient-to-r from-neon-purple to-neon-pink bg-clip-text text-transparent mt-2"> Criar o Futuro</span>
            </h2>

            <div className="space-y-4 md:space-y-6 text-base md:text-lg text-gray-300 leading-relaxed">
              <p>
                O <strong className="text-white">Freedom Experience</strong> foi criado para jovens de <strong className="text-neon-purple">8 a 17 anos</strong> que querem ir além do que a escola tradicional oferece, pois já entenderam que a educação formal só serve para criar empregados, e eles precisam é de educação real, pois querem ser os donos da empresa.
              </p>
              
              <p>
                Se seu filho é curioso, gosta de tecnologia, gosta de resolver problemas, quer ficar rico e quer aprender habilidades do futuro que realmente importam no mundo moderno, este curso é para ele.
              </p>

              <div className="grid sm:grid-cols-2 gap-3 md:gap-4 pt-2 md:pt-4">
                <div className="flex items-start gap-2 md:gap-3 p-3 md:p-4 bg-dark-800/50 backdrop-blur-sm border border-neon-purple/20 rounded-lg md:rounded-xl">
                  <i className="ri-checkbox-circle-fill text-xl md:text-2xl text-neon-purple mt-1 flex-shrink-0"></i>
                  <div>
                    <p className="text-white font-semibold text-sm md:text-base">Crianças curiosas</p>
                    <p className="text-gray-400 text-xs md:text-sm">Que adoram tecnologia</p>
                  </div>
                </div>
                <div className="flex items-start gap-2 md:gap-3 p-3 md:p-4 bg-dark-800/50 backdrop-blur-sm border border-neon-purple/20 rounded-lg md:rounded-xl">
                  <i className="ri-checkbox-circle-fill text-xl md:text-2xl text-neon-purple mt-1 flex-shrink-0"></i>
                  <div>
                    <p className="text-white font-semibold text-sm md:text-base">Jovens criativos</p>
                    <p className="text-gray-400 text-xs md:text-sm">Que querem criar</p>
                  </div>
                </div>
                <div className="flex items-start gap-2 md:gap-3 p-3 md:p-4 bg-dark-800/50 backdrop-blur-sm border border-neon-purple/20 rounded-lg md:rounded-xl">
                  <i className="ri-checkbox-circle-fill text-xl md:text-2xl text-neon-purple mt-1 flex-shrink-0"></i>
                  <div>
                    <p className="text-white font-semibold text-sm md:text-base">Futuros inovadores</p>
                    <p className="text-gray-400 text-xs md:text-sm">Que pensam diferente</p>
                  </div>
                </div>
                <div className="flex items-start gap-2 md:gap-3 p-3 md:p-4 bg-dark-800/50 backdrop-blur-sm border border-neon-purple/20 rounded-lg md:rounded-xl">
                  <i className="ri-checkbox-circle-fill text-xl md:text-2xl text-neon-purple mt-1 flex-shrink-0"></i>
                  <div>
                    <p className="text-white font-semibold text-sm md:text-base">Empreendedores</p>
                    <p className="text-gray-400 text-xs md:text-sm">Que querem liderar</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
